import {LinkType} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/meta_bar.types';
import {COLORS, GenericIconName, Icon} from '@aboutyou/ui-components';
import React from 'react';

interface MetaBarItemIconProps {
  type: LinkType;
}

export const MetaBarItemIcon: React.FC<MetaBarItemIconProps> = ({type}) => {
  switch (type) {
    case LinkType.CONTACT:
      return (
        <Icon
          asset={GenericIconName.QuestionMark}
          size="S"
          fill={COLORS.Grey1}
        />
      );
    case LinkType.SECOND_HAND_SERVICE:
      return (
        <Icon
          asset={GenericIconName.SecondHandService}
          size="S"
          fill={COLORS.Grey1}
        />
      );
    default:
      return null;
  }
};
